module.exports = __webpack_public_path__ + "static/rotamizmilli-92cb9934d1c40229eeebf4dc5890d62f.png";